<template>
    <div class="language-selector">
    <div class="language-selector__selector-wrapper">
        <a href="#" class="language-selector__selector">O’MELVENY WORLDWIDE</a>
    </div>
    </div>
</template>

<script>
import eventBus from "../services/eventBus.js";

export default {
    props: ["languages", "buttonTitle", "buttonLanguage", "currentLanguage", "languageSelectorButtonLabel", "languageSelectorTitle"],
    data() {
        return {
            show: false,
            selectedLanguage: { isoCode: "en", url: "/" }
        }
    },
    mounted() { 
       this.selectedLanguage.isoCode = this.currentLanguage
        // adding eventBus listener
        eventBus.$on('custom-event', () => {
        })
    },
    beforeDestroy() {
        // removing eventBus listener
        eventBus.$off('custom-event')
    },
    methods: {
        selectLanguage: function (language) {
            this.selectedLanguage = language
        },
        save: function () {
            window.location.href = this.selectedLanguage.url
        }
    }
}
</script>

